module.exports = __webpack_public_path__ + "static/favicon-70bbd932a51153271c0aa353e336b3a8.ico";